import { EmployeePaymentMethodType } from '@zorro/clients';
import { mapPlanToPaymentMethodType } from '@zorro/common-utils';

type PredictsAwaitingPaymentInput = {
  isAwaitingPaymentEnabled: boolean;
  premium: number | undefined;
  storedPremium: number | undefined;
  selfPayAmount: number | null | undefined;
  isInitialPremiumCompleted: boolean;
};

// Mirrors updateBenefitPremium: a fully self-paid plan follows the new premium,
// a partial self-pay is capped at it.
const resolveSelfPayAmount = (
  premium: number,
  storedPremium: number | undefined,
  selfPayAmount: number | null | undefined
) => {
  if (selfPayAmount === null || selfPayAmount === undefined) {
    return selfPayAmount;
  }
  return selfPayAmount === storedPremium
    ? premium
    : Math.min(premium, selfPayAmount);
};

// Mirrors the payment leg of the server's status resolution so the form knows
// when confirmation will land on Awaiting payment; the server stays the gate.
export function predictsAwaitingPayment({
  isAwaitingPaymentEnabled,
  premium,
  storedPremium,
  selfPayAmount,
  isInitialPremiumCompleted,
}: PredictsAwaitingPaymentInput): boolean {
  if (
    !isAwaitingPaymentEnabled ||
    isInitialPremiumCompleted ||
    premium === undefined
  ) {
    return false;
  }
  return (
    mapPlanToPaymentMethodType({
      premium,
      selfPayAmount: resolveSelfPayAmount(
        premium,
        storedPremium,
        selfPayAmount
      ),
    }) !== EmployeePaymentMethodType.SELF_PAY
  );
}
